import moment from 'moment';
import {
  isAnaliseRisco,
  isFotoFim,
  isFotoInicio,
  isFotoRegistro,
} from './nsmpRowTypes';

const FAIXA_INSPECIONADO_EM_FORMAT = 'DD/MM/YYYY HH:mm';

export const TIPO_NSMP_SERVICO = 'SERVICO';

const TIPO_NSMP_LABEL = {
  ANALISE_RISCO: 'Análise de Risco',
  FOTO_INICIO: 'Foto Inicial',
  FOTO_FIM: 'Foto Final',
  FOTO_REGISTRO: 'Foto Registro',
};

/**
 * Linha de serviço da empreiteira no fluxo novo de Auditoria de Faixa.
 * tipoNsmp === SERVICO (ou ausente) e sem flags de anexo (análise/foto).
 */
export const isFaixaServicoRow = (row) => {
  if (!row) return false;
  if (isAnaliseRisco(row) || isFotoInicio(row) || isFotoFim(row) || isFotoRegistro(row)) {
    return false;
  }
  if (row.tipoNsmp != null && row.tipoNsmp !== '' && row.tipoNsmp !== TIPO_NSMP_SERVICO) {
    return false;
  }
  return true;
};

export const getFaixaTipoLabel = (row) => {
  if (!row) return '';
  if (row.tipoNsmp && TIPO_NSMP_LABEL[row.tipoNsmp]) {
    return TIPO_NSMP_LABEL[row.tipoNsmp];
  }
  if (isFotoInicio(row)) return 'Foto Inicial';
  if (isFotoFim(row)) return 'Foto Final';
  if (isAnaliseRisco(row)) return 'Análise de Risco';
  if (isFotoRegistro(row)) {
    return row.codigo ? `Foto Registro ${row.codigo}` : 'Foto Registro';
  }
  if (row.tipoNsmp && row.tipoNsmp !== TIPO_NSMP_SERVICO) {
    return row.tipoNsmp;
  }
  return '';
};

export const getFaixaServicoTitle = (row) => {
  if (!row) return '';
  if (!isFaixaServicoRow(row)) {
    return getFaixaTipoLabel(row) || '—';
  }
  const numero = row.codigo || row.numeroServicoEmpreiteira;
  return numero != null && String(numero).trim() !== ''
    ? `Serviço ${numero}`
    : 'Serviço';
};

export const getFaixaInspecionadoEm = (row) => {
  if (!row) return null;
  if (row.inspecionadoEm != null && row.inspecionadoEm !== '') {
    const parsed = moment(row.inspecionadoEm);
    if (parsed.isValid()) return parsed.format(FAIXA_INSPECIONADO_EM_FORMAT);
  }
  if (row.inspecionadoEmValue) return row.inspecionadoEmValue;
  return null;
};
